import store from '@state/store'
import { RELOAD } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import { getUnique } from '@utils/Format'

const LOAD_STORAGE = (state) => {
  const user = store.getters['user/currentUser'] || {}
  if (user && user.id_interno > 0) {
    let sim = window.localStorage.getItem(`sim8dc${user.id_interno}1989c`)
    if (sim) {
      try {
        const parsed = JSON.parse(sim)
        if (Array.isArray(parsed)) {
          state.running = parsed
        }
      } catch (error) {
        console.warn('[simulador/LOAD_STORAGE] corrupted localStorage entry, falling back to default state:', error.message)
      }
    }
    GlobalBus.$emit(RELOAD.SIM_RUNNING, true)
  }
}

const SET_RUNNING = (state, payload) => {
  if (Array.isArray(payload)) {
    state.running = payload
  }
}

const ADD_RUNNING = (state, payload) => {
  if (payload && state.running.push) {
    state.running.unshift(payload)
    state.running = getUnique(state.running, 'hash_code')
  }
}

const UPDATE_RUNNING = (state, payload) => {
  if (payload && state.running) {
    state.running = state.running.map((s) => {
      if ((s.hash_code || s.hash) === (payload.hash_code || payload.hash)) {
        s = {
          ...s,
          ...payload,
        }
      }
      return s
    })
  }
}

const REMOVE_RUNNING = (state, payload) => {
  if (payload) {
    state.running = state.running.filter((s) => {
      return (s.hash || s.hash_code) !== (payload.hash || payload.hash_code)
    })
  }
}

const SET_HAS_SIMULATION = (state, payload) => {
  if (typeof payload !== 'undefined') {
    state.has_simulation = payload
  }
}

const SET_LOADING = (state, payload) => {
  state.loading = !!payload
}

export {
  LOAD_STORAGE,
  ADD_RUNNING,
  REMOVE_RUNNING,
  UPDATE_RUNNING,
  SET_RUNNING,
  SET_HAS_SIMULATION,
  SET_LOADING,
}
